import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import {debounceTime, distinctUntilChanged, fromEvent, map, Subscription, tap} from "rxjs";

require('./bringoz-search-input.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-search-input',
  templateUrl: './bringoz-search-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozSearchInputComponent implements AfterViewInit, OnDestroy {

  @Input() query: string = '';
  @Input() isDisabled: boolean;
  @Input() placeholder: string;
  @Input() minLength: number;
  @Output() queryChangeEvent = new EventEmitter<string>();

  @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
  private inputSubscription: Subscription;

  constructor() {
  }

  ngAfterViewInit() {
    this.searchInput.nativeElement.value = this.query || '';
    this.inputSubscription = fromEvent(this.searchInput.nativeElement, 'input').pipe(
      map((event: Event) => (event.target as HTMLInputElement).value),
      debounceTime(1000),
      distinctUntilChanged(),
      tap(value => this.queryChangeEvent.emit(value))
    ).subscribe();
  }

  ngOnDestroy() {
    this.inputSubscription.unsubscribe();
  }

  clear() {
    if (this.query) {
      this.searchInput.nativeElement.value = '';
      const event = new Event('input', {bubbles: true});
      this.searchInput.nativeElement.dispatchEvent(event);
    }
  }
}
